const COOKIE_NAME = 'dontShowTimezoneChangeModal';
const SHARED_COOKIE_DOMAIN = '.medable.com';
const COOKIE_PATH = '/';
const MAX_AGE_ONE_YEAR = 365 * 24 * 60 * 60;
function getCookieValue(name) {
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1].trim()) : null;
}
function getCookieDomain() {
    return window.location.hostname.endsWith('.medable.com') || window.location.hostname === 'medable.com'
        ? SHARED_COOKIE_DOMAIN
        : '';
}
export function getDontShowTimezoneChangeModal() {
    return getCookieValue(COOKIE_NAME) === 'true';
}
export function setDontShowTimezoneChangeModal() {
    const domain = getCookieDomain();
    const domainPart = domain ? `; domain=${domain}` : '';
    document.cookie = `${COOKIE_NAME}=true; path=${COOKIE_PATH}${domainPart}; max-age=${MAX_AGE_ONE_YEAR}; samesite=lax`;
}
